import { render, staticRenderFns } from "./users-edit.vue?vue&type=template&id=4c95eff6&scoped=true&"
import script from "./users-edit.vue?vue&type=script&lang=js&"
export * from "./users-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c95eff6",
  null
  
)

export default component.exports